import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12h6","key":"svg-0"}],["path",{"d":"M12 9v6","key":"svg-1"}],["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-2"}]]

const IconSquarePlus = createReactComponent('outline', 'square-plus', 'SquarePlus', __iconNode);

export default IconSquarePlus;